import React, { useEffect, useState, useRef } from 'react';
import { collection, onSnapshot, updateDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { Badge } from 'react-bootstrap';
import { FaRegBell } from 'react-icons/fa';

const Notification = () => {
    const [notifications, setNotifications] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        const unsub = onSnapshot(collection(db, 'notifications'), (snapshot) => {
            const notis = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            notis.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
            setNotifications(notis);
        });
        return () => unsub();
    }, []);

    const markAsSeen = async (id) => {
        try {
            await updateDoc(doc(db, 'notifications', id), { seen: true });
        } catch (err) {
            console.error('Error marking notification as seen:', err);
        }
    };

    const unseenCount = notifications.filter(noti => !noti.seen).length;

    const handleToggle = () => {
        setShowDropdown(prev => !prev);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className="position-relative" ref={dropdownRef}>
            {/* 
                new transaction — “A $50 payment has been received.”

                user report — “User reported an issue on transaction #12345.”

                error occur in anywhere — “Server error occurred at 2:30 PM.” 
            */}

            <button
                className="btn bg-transparent border-0 p-0 position-relative"
                onClick={handleToggle}
            >
                <FaRegBell size={20} />
                {unseenCount > 0 && (
                    <Badge bg="danger" pill className="position-absolute top-0 start-100 translate-middle">
                        {unseenCount}
                    </Badge>
                )}
            </button>

            {showDropdown && (
                <div
                    className="shadow rounded p-2 mt-2"
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '120%',
                        width: '300px',
                        maxHeight: '400px',
                        overflowY: 'auto',
                        backgroundColor: '#fff',
                        zIndex: 999
                    }}
                >
                    <h6 className="dropdown-header">Notifications</h6>
                    {notifications.length === 0 ? (
                        <p className="text-center text-muted">No notifications yet</p>
                    ) : (
                        notifications.map(noti => (
                            <div
                                key={noti.id}
                                onClick={() => markAsSeen(noti.id)}
                                className={`py-2 px-3 ${noti.seen ? '' : 'fw-bold'}`}
                                style={{ cursor: 'pointer' }}
                            >
                                <div>{noti.title}</div>
                                <small className="text-muted">{new Date(noti.timestamp).toLocaleString()}</small>
                            </div>
                        ))
                    )}
                </div>
            )}
        </div>
    );
};

export default Notification;
